import { m } from 'framer-motion';
import { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, Typography, useTheme, Box } from '@mui/material';
import { PropTypes } from 'prop-types';
import Slider from 'react-slick';
import { forceCheck } from 'react-lazyload';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';
import ImgBox from '../Box/ImgBox';
import { CarouselArrows } from '../../carousel';
import ImgFullScreen from '../Modals/ImgFullScreen';

DetailGalery.propTypes = {
  media: PropTypes.array,
  description: PropTypes.string,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.paper,
}));

export default function DetailGalery({ media, description }) {
  const theme = useTheme();
  const carouselRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [actualImgIdx, setActualImgIdx] = useState(0);

  const handlePrevious = () => {
    carouselRef.current?.slickPrev();
  };

  const handleNext = () => {
    carouselRef.current?.slickNext();
  };

  const mediaLength = media.length > 0 ? media.length : 1;

  const settings = {
    arrows: false,
    slidesToShow: mediaLength < 4 ? mediaLength : 4,
    centerMode: true,
    centerPadding: '0px',
    autoplay: false,
    autoplaySpeed: 4000,
    maxWidth: '1200px',
    responsive: [
      {
        breakpoint: 1279,
        settings: { slidesToShow: mediaLength < 4 ? mediaLength : 4 },
      },
      {
        breakpoint: 959,
        settings: { slidesToShow: mediaLength < 3 ? mediaLength : 3 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: mediaLength < 2 ? mediaLength : 2 },
      },
      {
        breakpoint: 460,
        settings: { slidesToShow: 1 },
      },
    ],
  };
  const forceLazyLoad = () => {
    forceCheck();
  };
  return (
    <>
      <RootStyle className="printable">
        <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
          <m.div>
            <CarouselArrows filled onNext={handleNext} onPrevious={handlePrevious} margin={0}>
              <Slider ref={carouselRef} {...settings} afterChange={forceLazyLoad}>
                {media.map((item, i) => (
                  <Box
                    key={i}
                    component={m.div}
                    /* variants={varFade().in} */ sx={{ px: 1, cursor: 'pointer' }}
                    onClick={() => {
                      setOpenModal(true);
                      setActualImgIdx(i);
                    }}
                  >
                    <Grid
                      key={i}
                      className="border-radius-12"
                      xs={12}
                      sx={{
                        overflow: 'hidden',
                        backgroundColor:
                          theme.palette.mode === 'dark' ? theme.palette.grey[1000] : theme.palette.grey[800],
                      }}
                      item
                    >
                      <ImgBox
                        className={`border-radius-top-12`}
                        sx={{ minWidth: '100%', height: '200px !important', objectFit: 'contain !important' }}
                        src={`${process.env.REACT_APP_API_URL}/image/download/${item.imageKey}?sizeIndex=1`}
                      />
                    </Grid>
                  </Box>
                ))}
              </Slider>
            </CarouselArrows>
            <Grid container>
              <Grid item xs={12} className="text-center">
                <Typography variant="h6" sx={{ padding: '6px' }}>
                  {description}
                </Typography>
              </Grid>
            </Grid>
          </m.div>
        </Container>
      </RootStyle>
      {media.length > 0 && (
        <ImgFullScreen open={openModal} onClose={() => setOpenModal(false)} image={actualImgIdx} images={media} />
      )}
    </>
  );
}
